import type { FaireProductEntity } from "../../entity_types/product";

export const p_8cruayjm6y: FaireProductEntity = {
  token: "p_8cruayjm6y",
  type: "product",
  name: "Minnesota Map Sticker - midwest, local, homegrown, roots",
  brandName: "Yarnival",
  imageUrl:
    "https://cdn.faire.com/fastly/f080a1dd645676ab712c83ab827d0b93fc676a52db1d4a28dcde8ef16a1976d5.png",
  priceDollars: 1.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a1e12377e6419629e169ecc67bc3d47af823e5d2500fe719d0088e399ea08163.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
